import { Receipt, Clock, Sparkles, AlertTriangle, ShoppingCart, Droplets } from "lucide-react";

export const CostOfSuppliesInfographic = () => {
  return (
    <div className="my-12 p-6 md:p-8 bg-card rounded-2xl border shadow-sm">
      <div className="text-center mb-8">
        <h3 className="text-2xl md:text-3xl font-bold mb-3">The True Cost of DIY Cleaning</h3>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          When you clean your own home, you aren't just spending time—you're spending money on supplies, equipment, and maintenance. Here is what the average homeowner spends annually.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div className="p-6 bg-muted/50 rounded-xl text-center">
          <div className="w-12 h-12 bg-primary/10 text-primary rounded-full flex items-center justify-center mx-auto mb-4">
            <ShoppingCart className="h-6 w-6" />
          </div>
          <h4 className="font-bold text-lg mb-2">Equipment</h4>
          <p className="text-3xl font-black text-primary mb-2">$350+</p>
          <p className="text-sm text-muted-foreground">Vacuums, mops, brooms, and dusters (annual replacement & maintenance).</p>
        </div>

        <div className="p-6 bg-muted/50 rounded-xl text-center">
          <div className="w-12 h-12 bg-primary/10 text-primary rounded-full flex items-center justify-center mx-auto mb-4">
            <Droplets className="h-6 w-6" />
          </div>
          <h4 className="font-bold text-lg mb-2">Supplies</h4>
          <p className="text-3xl font-black text-primary mb-2">$250+</p>
          <p className="text-sm text-muted-foreground">Sprays, wipes, sponges, glass cleaners, and specialty solutions.</p>
        </div>

        <div className="p-6 bg-muted/50 rounded-xl text-center">
          <div className="w-12 h-12 bg-primary/10 text-primary rounded-full flex items-center justify-center mx-auto mb-4">
            <Clock className="h-6 w-6" />
          </div>
          <h4 className="font-bold text-lg mb-2">Your Time</h4>
          <p className="text-3xl font-black text-primary mb-2">208 Hrs</p>
          <p className="text-sm text-muted-foreground">Average time spent cleaning per year (4 hours per week).</p>
        </div>

        <div className="p-6 bg-primary text-primary-foreground rounded-xl text-center shadow-md">
          <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <Sparkles className="h-6 w-6" />
          </div>
          <h4 className="font-bold text-lg mb-2">The Alternative</h4>
          <p className="text-xl font-bold mb-2">Professional Care</p>
          <p className="text-sm opacity-90">We bring our own premium supplies and equipment. You get your weekends back.</p>
        </div>
      </div>

      <div className="flex items-start gap-3 p-4 bg-accent/10 text-accent-foreground rounded-lg">
        <AlertTriangle className="h-5 w-5 shrink-0 mt-0.5 text-accent" />
        <p className="text-sm">
          <strong>Hidden Cost Alert:</strong> Using the wrong DIY cleaning chemicals on natural stone, hardwood floors, or stainless steel can cause thousands of dollars in permanent damage. Professional cleaners know exactly which products are safe for every surface.
        </p>
      </div>
    </div>
  );
};
